const GET_API_URL = (key) => {
  switch (key) {
    case 'production':
      return 'https://api.world4nada.com/api'
    case 'sandbox':
      return 'https://sandboxapi.world4nada.com/api'
    case 'local':
      return 'https://sandboxapi.world4nada.com/api'

    default:
      return 'http://localhost:9012/api'
  }
}

const GET_APP_URL = (key) => {
  switch (key) {
    case 'production':
      return 'https://world4nada.com'
    case 'sandbox':
      return 'https://sandbox.world4nada.com'

    case 'local':
      return 'http://localhost:9011'

    default:
      return 'http://localhost:9011'
  }
}

export default {
  API_URL: GET_API_URL(process.env.REACT_APP_STAGE),
  APP_URL: GET_APP_URL(process.env.REACT_APP_STAGE)
}
